module.exports = __webpack_public_path__ + "img/reading-stages-table.fb391760.png";